import Vue from "vue";
import Router from "vue-router";
import {
    validateDevice,
    clearLocalStorage
} from "@/providers/RoloProvider";

//Custom Components
import Login from "@/components/setup/login";
import KdsHome from "@/components/home";
import Init from "@/components/setup/init"
import EmployeeLogin from "@/components/employee/home"
import KitchenLines from "@/components/setup/kitchenLines"

Vue.use(Router);

const routes = [{
    path: "/",
    name: "login",
    component: Login,
    meta: {
        loginAuth: false,
    },
    props: true,
    beforeEnter: (to, from, next) => {
        if (!localStorage.getItem("_domain")) {
            next("/domainSetup");
            return;
        }
        if (validateDevice()) {
            let storeId = localStorage.getItem("storeId")
            next("/store/" + storeId + "/home");
            return;
        }

        clearLocalStorage();
        next()
    }
},
{
    path: "/store/:storeId/lines",
    name: "KitchenLines",
    component: KitchenLines,
    meta: {
        loginAuth: true
    }
},
{
    path: "/store/:storeId/home",
    name: "EmployeeLogin",
    component: EmployeeLogin,
    meta: {
        loginAuth: true
    }
},
{
    path: "/kds/home",
    name: "KdsHome",
    component: KdsHome,
    meta: {
        loginAuth: true,
        pinAuth: true,
    }
},
{
    path: "/domainSetup",
    name: "domainSetup",
    component: Init
},
{
    path: "*",
    redirect: "/"
}
];

const router = new Router({
    routes
});

//Router Authentication
router.beforeEach(function (to, from, next) {
    if (to.name !== "domainSetup" && !localStorage.getItem("_domain")) {
        next("/domainSetup");
        return;
    }
    if (!to.meta.loginAuth) {
        next();
        return;
    }
    if (!validateDevice()) {
        next("/")
        return;
    }
    if (to.name !== "KitchenLines") {
        let kl;
        let klData = localStorage.getItem("kitchenLine");
        if (klData) {
            kl = JSON.parse(klData);
        }
        if (!kl) {
            let storeId = localStorage.getItem("storeId")
            next("/store/" + storeId + "/lines");
            return
        }
    }

    if (to.meta.pinAuth && !localStorage.getItem("userId")) {
        let storeId = localStorage.getItem("storeId")
        next("/store/" + storeId + "/home");
        return;
    }

    next();
});


export default router;